import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingPigletPrimaryDataById, getFootprintingPigletPrimaryDataByIdAdmin } from "services";

import { getEnvironment, shouldRetryQueryError } from "utils";

import { FOOTPRINTING_PIGLET_PRIMARY_DATA } from "consts";

export const useGetFootprintingPigletPrimaryDataById = (primaryDataId: string, { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useQuery(
    {
      queryKey: [FOOTPRINTING_PIGLET_PRIMARY_DATA, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getFootprintingPigletPrimaryDataByIdAdmin(primaryDataId) : getFootprintingPigletPrimaryDataById(primaryDataId)),
      enabled: enabled && !!primaryDataId,
      gcTime: 60000,
      retry: shouldRetryQueryError(),
    },
    queryClient
  );
};
